"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_opacity = void 0;
exports.foundation_opacity = {
    opacity: {
        opacity_100: 1.00,
        opacity_90: 0.90,
        opacity_80: 0.80,
        opacity_70: 0.70,
        opacity_60: 0.60,
        opacity_50: 0.50,
        opacity_40: 0.40,
        opacity_30: 0.30,
        opacity_20: 0.20,
        opacity_10: 0.10,
        opacity_0: 0,
    }
};
//# sourceMappingURL=global.js.map